import { styled } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

export const SectionTitle = styled(Typography)(({ theme }) => ({
  borderBottom: `2px solid ${theme.palette.customColors.lightgrey} `,
  marginBottom: theme.spacing(1)
}));
